<template>
    <section class="rewards-header bg-grey">
        <div class="page-container flex-start">
            <figure class="logo">
                <a href="/">
                    <img src="/images/new.svg" alt="Ulta">
                </a>
            </figure>
        </div>
    </section>
</template>

<script>
export default {
    name: "LogoComponent",
}
</script>


<style>
.logo{
    width: 30%;
}
</style>